import Mask from 'inputmask/dist/inputmask.es6';

export default {
  mounted(el, binding) {
    let $input = el;

    if ($input.tagName !== 'INPUT') {
      $input = el.querySelector('input');
    }

    Mask.extendAliases({
      positiveNumber: {
        alias: 'integer',
        allowMinus: false,
        allowPlus: false,
        groupSeparator: ',',
        placeholder: '',
        autoUnmask: true,
        rightAlign: false,
      },
    });

    Mask(binding.value).mask($input);
  },
};
